import React from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import Manifesto from "@/components/site/Manifesto";
import Pricing from "@/components/site/Pricing";
import Gallery from "@/components/site/Gallery";
import BeforeAfter from "@/components/site/BeforeAfter";
import Testimonials from "@/components/site/Testimonials";
import Coverage from "@/components/site/Coverage";
import Contact from "@/components/site/Contact";
import FAQ from "@/components/site/FAQ";
import Footer from "@/components/site/Footer";
import SmoothScroll from "@/components/site/SmoothScroll";
import { useSite } from "@/hooks/useSite";
import { LOGO_FALLBACK } from "@/lib/api";
import { useT } from "@/context/LanguageContext";

export default function Home() {
  const { site, loading } = useSite();
  const { ui } = useT();

  if (loading || !site) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[color:var(--gcs-emerald)] text-[color:var(--gcs-ivory)]">
        <div className="flex flex-col items-center gap-4">
          <img src={LOGO_FALLBACK} alt="Loading" className="h-16 w-16 object-contain animate-pulse" />
          <span className="overline text-[color:var(--gcs-gold)]">{ui("state.loading")}</span>
        </div>
      </div>
    );
  }

  const logoUrl = site.hero?.logo_url || LOGO_FALLBACK;

  return (
    <>
      <SmoothScroll />
      <Header contact={site.contact} logoUrl={logoUrl} />
      <main className="bg-[color:var(--gcs-ivory)]" data-testid="home-main">
        <Hero hero={site.hero} contact={site.contact} />
        <Marquee words={site.marquee_words} />
        <Services services={site.services} />
        <Manifesto chapters={site.manifesto} />
        <Pricing tiers={site.pricing} />
        <Gallery images={site.gallery} />
        <BeforeAfter pairs={site.before_after} />
        <Testimonials items={site.testimonials} />
        <Coverage contact={site.contact} />
        <FAQ items={site.faq} />
        <Contact contact={site.contact} />
        <Footer contact={site.contact} logoUrl={logoUrl} />
      </main>
    </>
  );
}
